import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { LazyComponent } from "../../FundPagesNewDesign/core/LazyComponent";
import "../../FundPagesNewDesign/core/LazyComponent.scss"

import FundPageSecondaryNav from '../../FundPagesNewDesign/Blocks/secondaryNav/SecondaryNav';
import FundPageSecondaryNavAside from '../../FundPagesNewDesign/Blocks/secondaryNav/secondaryNavAside';
const ContentAreaBlock = React.lazy(() => import('../../FundPagesNewDesign/Blocks/ContentAreaBlock'));
const HTMLBlock = React.lazy(() => import('../../FundPagesNewDesign/Blocks/HtmlBlock'));
const HistoPricesBlock = React.lazy(() => import('../Components/HistoPricesBlock/HistoPricesBlock'));
const PremiumDiscountHistoryBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/PremiumDiscountHistoryBlock/PremiumDiscountHistoryBlock'));
const PerformanceHistoryBlock = React.lazy(()=>import('../../FundPagesNewDesign/Components/PerformanceHistoryBlock/PerformanceHistoryBlock') )
const PerformanceHistoryMultiFundBlock = React.lazy(()=>import('../../FundPages/Components/PerformanceHistoryMultiFundBlock/PerformanceHistoryMultiFundBlock'));
const HoldingsBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/HoldingsBlock/HoldingsBlock'));
const NavDistributionsBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/NavDistributionsBlock/NavDistributionsBlock'));
const HoldingsWeightingsChartBlock = React.lazy(()=>import('../../FundPagesNewDesign/Components/HoldingsWeightingsChartblock/HoldingsWeightingsChartBlock'));
const HypotheticalChartBlock = React.lazy(()=>import('../Components/HypotheticalChartBlock/HypotheticalChartBlock'));
const HypotheticalLinearChartBlock = React.lazy(()=>import('../../FundPagesNewDesign/Components/HypotheticalLinearChartBlock/HypotheticalLinearChartBlock'));
const PerformanceYearlyReturnsBlock = React.lazy(()=>import('../../FundPagesNewDesign/Components/PerformanceYearlyReturnsBlock/PerformanceYearlyReturnsBlock'));
const MorningstarRatingBlock = React.lazy(()=>import('../../FundPagesNewDesign/Components/MorningstarRatingBlock/MorningstarRatingBlock'));
const OneColumnUsBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/OneColumnUsBlock/OneColumnUsBlock'));
const PersonUsBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/PersonUsBlock/PersonUsBlock'));
const FundDetailsBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/FundDetailsBlock/FundDetailsBlock'));
const DiscountViolationBlock = React.lazy(() => import('../../FundPages/Components/DiscountViolationBlock/DiscountViolationBlock'));
const IndexBenchmarkChartBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/IndexBenchmarkChartBlock/IndexBenchmarkChartBlock'));
const HoldingsCreditQualityBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/HoldingsCreditQualityBlock/HoldingsCreditQualityBlock'));
const NavTickerBlock = React.lazy(() => import('../../FundPages/Components/NavTickerBlock/NavTickerBlock'));
const HistoPricesChartBlock = React.lazy(()=>import('../../FundPages/Components/HistoPricesChartBlock/HistoPricesChartBlock'));
const IndexFundamentalsBlock = React.lazy(()=>import('../../FundPages/Components/IndexFundamentalsBlock/IndexFundamentalsBlock'));
const AnalyticsCustomBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/AnalyticsCustomBlock/AnalyticsCustomBlock'));
const NavInformationBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/NavInformationBlock/NavInformationBlock'));
const FundFeesChargesBlock = React.lazy(()=>import('../../FundPages/Components/FundFeesAndChargesBlock/FundFeesChargesBlock'));
const AccountMinimumBlock = React.lazy(()=>import('../../FundPages/Components/AccountMinimumBlock/AccountMinimumBlock'));
const FundExpensesBlock = React.lazy(()=>import('../../FundPages/Components/FundExpensesBlock/FundExpensesBlock'));
const PerformanceAnnualReturnsBlock = React.lazy(()=>import('../../FundPages/Components/PerformanceAnnualReturnsBlock/PerformanceAnnualReturnsBlock'));
const HoldingsWeightingsBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/HoldingsWeightingsBlock/HoldingsWeightingsBlock'));
const NavInformationUsBlock = React.lazy(()=>import('../../FundPages/Components/NavInformationUsBlock/NavInformationUsBlock'));
const DisclosureBlock = React.lazy(() => import('../../FundPagesNewDesign/Blocks/DisclosureBlock'));
const EmptyComponent = React.lazy(() => import('../../FundPages/Components/EmptyComponent/EmptyComponent'));
const IndexCurrencyExposureBlock = React.lazy(() => import('../../FundPages/Components/IndexCurrencyExposureBlock/IndexCurrencyExposureBlock'));
const RecommendationsBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/RecommendationsBlock/RecommendationsBlock'));
const AccordionBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/AccordionBlock/AccordionBlock'));
const FundCarouselBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/FundCarouselBlock/FundCarouselBlock'));
const IndexKeyPoints = React.lazy(() => import('../../FundPagesNewDesign/Components/IndexKeyPoints/IndexKeyPoints'));
const DocumentsBlock = React.lazy(() => import('../Components/DocumentsBlock/DocumentsBlock'));
const AwardsCarouselBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/AwardsCarouselBlock/AwardsCarouselBlock'));
const OverviewHTMLBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/OverviewHtmlBlock/OverviewHtmlBlock'));
const ReferenceLinksBlock = React.lazy(() => import('../Components/ReferenceLinksBlock/ReferenceLinksBlock'));
const VideoBlockWithCta = React.lazy(() => import('../../FundPagesNewDesign/Blocks/VideoBlock/VideoBlockWithCta'));
const MainRisksBlock = React.lazy(() => import('../Components/MainRisksBlock/MainRisksBlock'));
const PerformanceMetricsBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/PerformanceMetricsBlock/PerformanceMetricsBlock'));
const TradingInformationBlock = React.lazy(()=> import('../Components/TradingInformationBlock/TradingInformationBlock'));
const PerformanceScenarioHistoryBlock = React.lazy(()=> import('../Components/PerformanceScenarioHistoryBlock/PerformanceScenarioHistoryBlock'));
const PerformancePastYearsChartBlock = React.lazy(()=>import('../Components/PerformancePastYearsChartBlock/PerformancePastYearsChartBlock'));
const GenericFundBlock = React.lazy(()=> import('../Components/GenericFundBlock/GenericFundBlock'))
const IndexHoldingsBlock = React.lazy(()=> import('../../FundPagesNewDesign/Components/IndexHoldingsBlock/IndexHoldingsBlock'))
const ShowMoreBlock = React.lazy(() => import('../../FundPagesNewDesign/Components/ShowMoreBlock/ShowMoreBlock'));
const LatestInsightsBlock = React.lazy(() => import('../Components/LatestInsightsBlock/LatestInsightsBlock'));

//Bots
const isCrawler = /Bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
const blockTypes = [
    {
        name: "SecondaryNav",
        tagName: "ve-fundpagesecondarynav",
        component: FundPageSecondaryNav,
        LoadImmediately: true
    },
    {
        name: "SecondaryNavAside",
        tagName: "ve-fundpagesecondarynavaside",
        component: FundPageSecondaryNavAside,
        LoadImmediately: true
    },
    {
        name: "ContentAreaBlock",
        tagName: "ve-contentareablock",
        component: ContentAreaBlock,
        LoadImmediately: false,
        template: ""
    },
    {
        name: "HTMLBlock",
        tagName: "ve-htmlblock",
        component: HTMLBlock,
        LoadImmediately: false,
        template: ""
    },
    {
        name: "PersonUsBlock",
        tagName: "ve-contentareablock",
        component: PersonUsBlock,
        LoadImmediately: false,
        template: "PersonUsBlocks",
        IgnoreForCrawlers: true
    },
    {
        name: "HistoPricesBlock",
        tagName: "ve-histopricesblock",
        component: HistoPricesBlock,
        LoadImmediately: false
    },
    {
        name: "PremiumDiscountHistoryBlock",
        tagName: "ve-premiumdiscounthistoryblock",
        component: PremiumDiscountHistoryBlock,
        LoadImmediately: false
    },
    {
        name: "PerformanceHistoryBlock",
        tagName: "ve-performancehistoryblock",
        component: PerformanceHistoryBlock,
        LoadImmediately: false
    },
    {
        name: "PerformanceHistoryMultiFundBlock",
        tagName: "ve-performancehistorymultifundblock",
        component: PerformanceHistoryMultiFundBlock,
        LoadImmediately: false
    },
    {
        name: "HoldingsWeightingsChartBlock",
        tagName: "ve-holdingsweightingschartblock",
        component: HoldingsWeightingsChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "PerformanceYearlyReturns",
        tagName: "ve-performanceyearlyreturnsblock",
        component: PerformanceYearlyReturnsBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "HypotheticalChartBlock",
        tagName: "ve-hypotheticalchartblock",
        component: HypotheticalChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "HypotheticalLinearChartBlock",
        tagName: "ve-hypotheticalchartblock",
        component: HypotheticalLinearChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true,
        template: "HypotheticalLinearChartBlock"
    },
    {
        name: "HoldingsBlock",
        tagName: "ve-holdingsblock",
        component: HoldingsBlock,
        LoadImmediately: false
    },
    {
        name: "NavDistributionsBlock",
        tagName: "ve-navdistributionsblock",
        component: NavDistributionsBlock
    },
    {
        name: "OneColumnUsBlock",
        tagName: "ve-onecolumnusblock",
        component: OneColumnUsBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "MorningstarRatingBlock",
        tagName: "ve-morningstarblock",
        component: MorningstarRatingBlock,
        LoadImmediately: false
    },
    {
        name: "FundDetailsBlock",
        tagName: "ve-fund-details-block",
        component: FundDetailsBlock,
        LoadImmediately: false
    },
    {
        name: "DiscountViolationBlock",
        tagName: "ve-discount-violation-block",
        component: DiscountViolationBlock,
        LoadImmediately: false
    },
    {
        name: "IndexBenchmarkChartBlock",
        tagName: "ve-indexbenchmarkschartblock",
        component: IndexBenchmarkChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "HoldingsCreditQualityBlock",
        tagName: "ve-holdingscreditqualityblock",
        component: HoldingsCreditQualityBlock,
        LoadImmediately: false
    },
    {
        name: "NavTickerBlock",
        tagName: "ve-navtickerblock",
        component: NavTickerBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "HistoPricesChartBlock",
        tagName: "ve-histopricechartblock",
        component: HistoPricesChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "IndexFundamentalsBlock",
        tagName: "ve-indexfundamentalsblock",
        component: IndexFundamentalsBlock,
        LoadImmediately: false
    },
    {
        name: "AnalyticsCustomBlock",
        tagName: "ve-analyticscustomblock",
        component: AnalyticsCustomBlock,
        LoadImmediately: false
    },
    {
        name: "FundFeesChargesBlock",
        tagName: "ve-fundfeesandchargesblock",
        component: FundFeesChargesBlock,
        LoadImmediately: false
    },
    {
        name: "AccountMinimumBlock",
        tagName: "ve-onecolumnusblock",
        component: AccountMinimumBlock,
        LoadImmediately: false,
        template: "AccountMinimumBlock"
    },
    {
        name: "FundExpensesBlock",
        tagName: "ve-fundexpensesblock",
        component: FundExpensesBlock,
        LoadImmediately: false
    },
    {
        name: "PerformanceAnnualReturnsBlock",
        tagName: "ve-performanceannualreturnsblock",
        component: PerformanceAnnualReturnsBlock,
        LoadImmediately: false
    },
    {
        name: "HoldingsWeightingsBlock",
        tagName: "ve-holdingsweightingsblock",
        component: HoldingsWeightingsBlock,
        LoadImmediately: false
    },
    {
        name: "NavInformationBlock",
        tagName: "ve-navinformationblock",
        component: NavInformationBlock,
        LoadImmediately: false
    },
    {
        name: "NavInformationUsBlock",
        tagName: "ve-navinformationblock",
        component: NavInformationUsBlock,
        LoadImmediately: false,
        template: "NavInformationUsBlock"
    },
    {
        name: "DisclosureBlock",
        tagName: "ve-disclosureblock",
        component: DisclosureBlock,
        LoadImmediately: false
    },
    {
        name: "EmptyComponent",
        tagName: "ve-emptycomponent",
        component: EmptyComponent,
        LoadImmediately: false
    },
    {
        name: "IndexCurrencyExposureBlock",
        tagName: "ve-index-currency-exposure-block",
        component: IndexCurrencyExposureBlock,
        LoadImmediately: false
    },
    {
        name: "RecommendationsBlock",
        tagName: "ve-recommendations-block",
        component: RecommendationsBlock,
        LoadImmediately: false,
        template: ""
    },
    {
        name: "FundCarouselBlock",
        tagName: "ve-fundcarouselusblock",
        component: FundCarouselBlock,
        LoadImmediately: false,
        template: ""
    },
    {
        name: "AccordionBlock",
        tagName: "ve-accordionblock",
        component: AccordionBlock,
        LoadImmediately: false
    },
    {
      name: "IndexKeyPoints",
      tagName: "ve-htmlblock",
      component: IndexKeyPoints,
      LoadImmediately: false,
      template: "IndexKeyPoints"
    },
    {
        name: "DocumentsBlock",
        tagName: "ve-onecolumnucitsblock",
        component: DocumentsBlock,
        LoadImmediately: false,
        template: "DocumentsBlock"
    },
    {
        name: "AwardsCarouselBlock",
        tagName: "ve-contentareablock",
        component: AwardsCarouselBlock,
        template: "AwardsCarouselBlock",
        LoadImmediately: false,
    },
    {
        name: "OverviewHTMLBlock",
        tagName: "ve-htmlblock",
        component: OverviewHTMLBlock,
        LoadImmediately: false,
        template: "OverviewHTMLBlock"
    },
    {
        name: "ReferenceLinksBlock",
        tagName: "ve-referencelinksblock",
        component: ReferenceLinksBlock,
        LoadImmediately: false
    },
    {
        name: "VideoBlockWithCta",
        tagName: "ve-videousblock",
        component: VideoBlockWithCta,
        LoadImmediately: false,
        template: "VideoBlockWithCta"
    },
    {
        name: "MainRisksBlock",
        tagName: "ve-tabcontentucitsblock",
        component: MainRisksBlock,
        LoadImmediately: false,
        template: "MainRisksBlock"
    },
    {  
        name: "PerformanceMetricsBlock",
        tagName: "ve-contentareablock",
        component: PerformanceMetricsBlock,
        LoadImmediately: false,
        template: "PerformanceMetricsBlock"
    },
    {
        name: "TradingInformationBlock",
        tagName: "ve-tradinginformationblock",
        component: TradingInformationBlock,
        LoadImmediately: false
    },
    {
        name: "PerformanceScenarioHistoryBlock",
        tagName: "ve-performancescenariohistoryblock",
        component: PerformanceScenarioHistoryBlock,
        LoadImmediately: false
    },
    {
        name: "PerformancePastYearsChartBlock",
        tagName: "ve-performancepastyearschartblock",
        component: PerformancePastYearsChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "GenericFundBlock",
        tagName: "ve-generic-fund-info-block",
        component: GenericFundBlock,
        LoadImmediately: false
    },
    {
        name: "IndexHoldingsBlock",
        tagName: "ve-indexholdingsblock",
        component: IndexHoldingsBlock,
        LoadImmediately: false
    },
    {
        name: "ShowMoreBlock",
        tagName: "ve-showmoreblock",
        component: ShowMoreBlock,
        LoadImmediately: true
    },
    {
        name: "LatestInsightsBlock",
        tagName: "ve-latestinsightsblock",
        component: LatestInsightsBlock,
        LoadImmediately: false
    },
]

export function processMarkup(rootElem = document) {
    //If it is a crawler, remove the blocks that are too slow to load.
    let blockTypesToRender = blockTypes;
    if (isCrawler) {
        blockTypesToRender = blockTypes.filter(block => {
            return typeof (block.IgnoreForCrawlers) == "undefined" || block.IgnoreForCrawlers == false;
        })
    }

    for (const block of blockTypesToRender) {
        var containers = rootElem.getElementsByTagName(block.tagName)
        if (block.template != null) {
            containers = Array.from(containers).filter(x => x.dataset.template == block.template)
        }
        for (const container of containers) {
            // @ts-ignore
            if (!container._reactRoot) {
                // @ts-ignore
                container._reactRoot = createRoot(container);
            }
            
            const { component, LoadImmediately } = block;
            // @ts-ignore
            container._reactRoot.render(
                <Suspense fallback={<div className="component-loading">Loading...</div>}>
                    <LazyComponent component={component} rootElement={container} loadImmediately={LoadImmediately} />
                </Suspense>
            );
        }
    }
}